export const OnboardingState = {
  CONNECTED: 'connected',
  FINALISED: 'finalised',
  FEED_CREATED: 'feed_created',
};
